// extracted by mini-css-extract-plugin
export var container = "_9f-0";
export var error = "_9f-9";
export var label = "_9f-5";
export var light = "_9f-6";
export var md = "_9f-3";
export var sm = "_9f-2";
export var thin = "_9f-8";
export var thinBold = "_9f-7";
export var vertical = "_9f-4";
export var xs = "_9f-1";